import { Box, Drawer, Toolbar } from "@mui/material";
import DrawerContent from "./DrawerContent";
import { useStoreContext } from "..";

const AppDrawer = () => {
  const { routerStore, keycloakStore } = useStoreContext();
  return (
    <Drawer
      variant="permanent"
      anchor="left"
      sx={{
        display: { xs: "none", md: "block" },
        zIndex: 5,
        width: 240,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: 240,
          boxSizing: "border-box",
        },
      }}
    >
      <Toolbar />
      <Box sx={{ overflow: "auto" }}>
        <DrawerContent
          onLinkClick={(url: string) => routerStore.history.push(url)}
          onLogout={() => keycloakStore.logout()}
        />
      </Box>
    </Drawer>
  );
};

export default AppDrawer;
